module.exports = "images/location_museum.33eb5772962d7e43081f91cb854e0486.png";